// Сборка исполняющей части сайта без AngularJS: выражения, области, компилятор, директивы.
import { createParse } from './parse';
import { createFilters } from './filters';
import { createRootScope } from './scope';
import { createAnimate, ANGULAR_CSS } from './animate';
import { createCompiler } from './compile';
import { registerCoreDirectives } from './directives';
import { registerRepeat } from './repeat';
import { registerModelDirectives } from './model';

export function createRuntime() {
    let filters;
    const parse = createParse(name => filters.get(name));
    filters = createFilters();

    const templateCache = new Map();
    const runtime = {
        parse,
        filters,
        animate: createAnimate(),
        directives: new Map(),
        controllers: new Map(),
        // Шаблон директивы по адресу (templateUrl) загружается один раз.
        templates(url) {
            if (!templateCache.has(url)) {
                templateCache.set(url, fetch(url, { credentials: 'same-origin' }).then(response => {
                    if (!response.ok) {
                        throw new Error(`Шаблон ${url} не загружен: ${response.status}`);
                    }
                    return response.text();
                }));
            }
            return templateCache.get(url);
        },
    };
    runtime.rootScope = createRootScope(parse);
    registerCoreDirectives(runtime.directives);
    registerRepeat(runtime.directives);
    registerModelDirectives(runtime.directives);
    const compiler = createCompiler(runtime);
    runtime.compile = (node, scope) => compiler.compile(node, scope || runtime.rootScope);

    // Обновляет страницу после внешнего события (ответ сервера, таймер).
    let scheduled = false;
    runtime.scheduleDigest = () => {
        if (scheduled) {
            return;
        }
        scheduled = true;
        setTimeout(() => {
            scheduled = false;
            if (!runtime.rootScope.$$phase) {
                runtime.rootScope.$digest();
            }
        }, 0);
    };
    return runtime;
}

// Правила ng-hide и ng-cloak действуют ещё до запуска приложения, как в angular.js.
export function injectAngularCss(doc = document) {
    if (doc.getElementById('sd-angular-css')) {
        return;
    }
    const style = doc.createElement('style');
    style.id = 'sd-angular-css';
    style.type = 'text/css';
    style.textContent = ANGULAR_CSS;
    doc.head.insertBefore(style, doc.head.firstChild);
}
